import request from "@/utils/request";

export function analyzeRedeemCsv(formData, option = {}) {
  return request({ url: "/redeem/csv/analyze", method: "post", data: formData, headers: { "Content-Type": "multipart/form-data" }, ...option });
}

export function estimateRedeemCsv(data, option = {}) {
  return request({ url: "/redeem/csv/estimate", method: "post", data, ...option });
}

export function startRedeemCsv(data, option = {}) {
  return request({ url: "/redeem/csv/start", method: "post", data, ...option });
}

export function queryRedeemCsv(data, option = {}) {
  return request({ url: "/redeem/csv/query", method: "post", data, ...option });
}

export function listRedeemCsv(data, option = {}) {
  return request({ url: "/redeem/csv", method: "post", data, ...option });
}

// profile_id is in the path (mirrors /attachments/hash/:profile_id/:hash) since GETs don't carry a body.
export function downloadRedeemCsv(profile_id, redeem_query_id, option = {}) {
  return request({ url: `/redeem/csv/${profile_id}/${redeem_query_id}/download`, method: "get", responseType: "blob", ...option });
}

export function getPeopleContactTypes(option = {}) {
  return request({ url: "/people/contacts/types", method: "get", ...option });
}

export function getEnrichmentConstants(option = {}) {
  return request({ url: "/redeem/csv/constants", method: "get", ...option });
}
